import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "l-modal__bg"
}
const _hoisted_2 = { class: "address" }
const _hoisted_3 = { class: "loading" }
const _hoisted_4 = { style: {"padding-bottom":"500px"} }
const _hoisted_5 = { style: {"padding-top":"40px"} }
const _hoisted_6 = { class: "text-area" }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { style: {"padding-top":"40px"} }
const _hoisted_9 = { class: "text-area" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { style: {"padding-top":"40px"} }
const _hoisted_13 = { class: "text-area" }
const _hoisted_14 = { class: "error" }
const _hoisted_15 = { style: {"padding-top":"40px"} }
const _hoisted_16 = { class: "text-area" }
const _hoisted_17 = { class: "error" }
const _hoisted_18 = { style: {"padding-top":"40px"} }
const _hoisted_19 = { class: "text-area" }
const _hoisted_20 = { class: "error" }
const _hoisted_21 = { style: {"padding-top":"40px"} }
const _hoisted_22 = { class: "text-area" }
const _hoisted_23 = { class: "error" }
const _hoisted_24 = { style: {"padding-top":"40px"} }
const _hoisted_25 = { class: "text-area" }
const _hoisted_26 = { class: "error" }
const _hoisted_27 = { class: "button-area" }

import { onBeforeMount, ref } from "vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { Field, Form, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";

import * as yup from "yup";
import { Core as YubinBangoCore } from "yubinbango-core2";
import { addressRegistRequest } from "../types/apiRequest";
import { useRouter } from "vue-router";
import { PREFECTURE } from "../consts/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const postalCode = ref("");
const prefecture = ref("");
const city = ref("");
const street = ref("");
const building = ref("");
const phoneNumber = ref("");
const name = ref("");
const updated = ref(false);
const router = useRouter();
const userInfoStore = UserInfoStore();
const loading = ref(false);
const deleting = ref(false);
const validationSchema = ref(
  yup.object().shape({
    postalCode: yup
      .string()
      .trim()
      .required("郵便番号は必須です")
      .min(1)
      .label("郵便番号"),
    prefecture: yup
      .string()
      .trim()
      .required("都道府県は必須です")
      .min(1)
      .label("都道府県"),
    city: yup.string().trim().required("市区町村は必須です").label("市区町村"),
    street: yup.string().trim().required("番地は必須です").label("番地"),
    phoneNumber: yup
      .string()
      .trim()
      .required("電話番号は必須です")
      .label("電話番号"),
    name: yup.string().trim().required("名前は必須です").label("名前"),
  })
);
onBeforeMount(async () => {
  if (userInfoStore.addressInfo.id < 0) {
    await userInfoStore.getAddressInfo().then(() => {
      if (userInfoStore.addressInfo.id < 0) {
        document.title = "配送先住所登録";
        return;
      }
      setInitialData();
    });
  } else {
    // 登録済の情報を初期値で入れる
    setInitialData();
  }
});

const setInitialData = () => {
  if (userInfoStore.addressInfo.id < 0) return;
  document.title = "配送先住所更新";
  postalCode.value = userInfoStore.addressInfo.postal_code;
  prefecture.value = userInfoStore.addressInfo.prefecture;
  city.value = userInfoStore.addressInfo.city;
  street.value = userInfoStore.addressInfo.street;
  building.value = userInfoStore.addressInfo.building || "";
  phoneNumber.value = userInfoStore.addressInfo.phone_number;
  name.value = userInfoStore.addressInfo.name;
};

function fetchAddress() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new YubinBangoCore(postalCode.value, function (addr: any) {
    // region=都道府県, locality=市区町村, street=町域
    prefecture.value = addr.region;
    city.value = addr.locality + addr.street;
  });
}

// 登録処理
const onSubmit = async () => {
  // 複数回リクエストが飛ばないようにする
  if (loading.value) return;
  loading.value = true;
  const request: addressRegistRequest = {
    postal_code: postalCode.value, //郵便番号
    prefecture: prefecture.value, //都道府県
    city: city.value, //市区町村
    street: street.value, //番地以降
    building: building.value || "", //ビル名など
    phone_number: phoneNumber.value, //電話番号
    name: name.value, //名前
  };

  await userInfoStore.updateAddressInfo(request).then((v) => {
    if (v) {
      updated.value = true;
      router.go(-1);
    }
    loading.value = false;
  });
};
async function deleteAddressInfo() {
  deleting.value = true;
  await userInfoStore.deleteAddressInfo().then((v) => {
    if (v) {
      updated.value = true;
      setTimeout(() => router.go(-2), 100);
    }

    deleting.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _cache[9] || (_cache[9] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
      ]), 512 /* NEED_PATCH */), [
        [_vShow, loading.value]
      ]),
      _createCommentVNode(" <header class=\"header\">\n      <img src=\"../assets/omi-logo.svg\" />\n    </header> "),
      _createCommentVNode(" <div class=\"title\">\n        <p v-if=\"!isUser\">事前登録受付</p>\n        <p v-else>ユーザー情報更新</p>\n      </div> "),
      _createVNode(_unref(Form), {
        class: "form h-adr",
        validationSchema: validationSchema.value
      }, {
        default: _withCtx(({ meta: { valid } }) => [
          _cache[18] || (_cache[18] = _createElementVNode("span", {
            class: "“p-country-name”",
            style: {"display":"none"}
          }, "Japan", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, "郵便番号", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Field), {
                  class: "text-field p-postal-code",
                  type: "text",
                  inputmode: "numeric",
                  name: "postalCode",
                  modelValue: postalCode.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((postalCode).value = $event)),
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (fetchAddress())),
                  tabindex: "1"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "postalCode" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", null, "都道府県", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Field), {
                  class: "select-field p-region",
                  as: "select",
                  name: "prefecture",
                  modelValue: prefecture.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((prefecture).value = $event)),
                  tabindex: "2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(_unref(PREFECTURE)), ([val]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: val,
                        key: val,
                        class: "p-region"
                      }, _toDisplayString(val), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "prefecture" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[12] || (_cache[12] = _createElementVNode("label", null, "市区町村", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Field), {
                  class: "text-field p-locality",
                  type: "text",
                  name: "city",
                  modelValue: city.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((city).value = $event)),
                  tabindex: "3"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "city" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "番地", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Field), {
                  class: "text-field p-street-address p-extended-address",
                  type: "text",
                  name: "street",
                  placeholder: "1-1-1",
                  modelValue: street.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((street).value = $event)),
                  tabindex: "4"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "street" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[14] || (_cache[14] = _createElementVNode("label", null, "建物名・部屋番号", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(Field), {
                  class: "text-field",
                  type: "text",
                  name: "building",
                  placeholder: "〇〇マンション101",
                  modelValue: building.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((building).value = $event)),
                  tabindex: "5"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "building" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_20, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "電話番号", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(Field), {
                  type: "text",
                  inputmode: "numeric",
                  modelValue: phoneNumber.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((phoneNumber).value = $event)),
                  name: "phoneNumber",
                  placeholder: "09000000000",
                  class: "text-field",
                  disabled: loading.value || deleting.value,
                  tabindex: "7"
                }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(ErrorMessage), { name: "phoneNumber" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[17] || (_cache[17] = _createElementVNode("label", null, "名前", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(Field), {
                  type: "text",
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((name).value = $event)),
                  name: "name",
                  placeholder: "山田 太郎",
                  class: "text-field",
                  disabled: loading.value || deleting.value,
                  tabindex: "8"
                }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("p", { style: {"font-size":"12px","color":"#2c3e50"} }, " ※職場などの場合は、会社名 部署 氏名まで入力してください ", -1 /* HOISTED */)),
                  _createVNode(_unref(ErrorMessage), { name: "name" }, {
                    default: _withCtx(({ message }) => [
                      _createElementVNode("p", _hoisted_26, _toDisplayString(message), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            (_unref(userInfoStore).addressInfo.id < 0)
              ? (_openBlock(), _createBlock(CommonButton, {
                  key: 0,
                  data: {
            status: !valid || loading.value ? 2 : 0,
            button: deleting.value ? `登録中` : `登録`,
          },
                  onClick: ($event: any) => (valid && !loading.value && !deleting.value ? onSubmit() : '')
                }, null, 8 /* PROPS */, ["data", "onClick"]))
              : (_openBlock(), _createBlock(CommonButton, {
                  key: 1,
                  data: {
            status: !valid || loading.value ? 2 : 0,
            button: loading.value ? `更新中` : `更新`,
          },
                  onClick: ($event: any) => (valid && !loading.value && !deleting.value ? onSubmit() : ''),
                  disabled: !valid || loading.value,
                  style: {"margin-bottom":"20px"}
                }, null, 8 /* PROPS */, ["data", "onClick", "disabled"])),
            (_unref(userInfoStore).addressInfo.id > 0)
              ? (_openBlock(), _createBlock(CommonButton, {
                  key: 2,
                  data: {
            status: 3,
            button: deleting.value ? `削除中` : `削除`,
          },
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (!loading.value && !deleting.value ? deleteAddressInfo() : ''))
                }, null, 8 /* PROPS */, ["data"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["validationSchema"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})